





















import { Component, Vue } from "vue-property-decorator";
import GroupActivitySection from "@/components/groupType/index/GroupActivitySection.vue";
import ActivityInstName from "@/components/common/edit/ActivityInstName.vue";
import ActivityTitle from "@/components/common/edit/ActivityTitle.vue";
import ActivityDeadline from "@/components/common/edit/ActivityDeadline.vue";
import ActivityStartTime from "@/components/common/edit/ActivityStartTime.vue";
import ActivityMainImageEdit from "@/components/common/edit/ActivityMainImageEdit.vue";
import SelectInst from "@/components/common/edit/SelectInst.vue";
import DashLine from '@/components/common/edit/DashLine.vue';
import { Getter } from "vuex-class";

@Component({
  components: {
    "group-activity-section": GroupActivitySection,
    "activity-inst-name": ActivityInstName,
    "activity-title": ActivityTitle,
    "activity-deadline": ActivityDeadline,
    "activity-start-time": ActivityStartTime,
    "activity-main-image-edit": ActivityMainImageEdit,
    "select-inst": SelectInst,
    "dash-line": DashLine
    
  }
})
export default class ActivitySetting extends Vue {
  @Getter("orgId") orgId!: string;
  @Getter("version") version!: string;
  @Getter("xcxFlag") xcxFlag!: boolean;
}
